var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.025,
    height: 17.025,
    viewBox: "0 0 17.025 17.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M14.191,8.1a3.1,3.1,0,1,1-.907-2.189A3.1,3.1,0,0,1,14.191,8.1Zm-1.548,0A1.548,1.548,0,1,1,12.19,7,1.548,1.548,0,0,1,12.643,8.1Z",
    transform: "translate(-1.583 -0.904)",
    fill: "#111",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M9.513,1a8.513,8.513,0,1,0,8.513,8.513A8.513,8.513,0,0,0,9.513,1ZM2.548,9.513A6.939,6.939,0,0,0,4.024,13.8a6.962,6.962,0,0,1,11.027-.065,6.965,6.965,0,1,0-12.5-4.224Zm6.965,6.965a6.934,6.934,0,0,1-4.389-1.557,5.416,5.416,0,0,1,8.842-.053A6.934,6.934,0,0,1,9.513,16.478Z",
    fill: "#111",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon1);
export default __webpack_public_path__ + "static/media/note-icon1.454da6a075ee2960e222d47b7d3ade13.svg";
export { ForwardRef as ReactComponent };